import { render, staticRenderFns } from "./WorkPermitList.vue?vue&type=template&id=260d3ab0&scoped=true"
import script from "./WorkPermitList.vue?vue&type=script&lang=js"
export * from "./WorkPermitList.vue?vue&type=script&lang=js"
import style0 from "./WorkPermitList.vue?vue&type=style&index=0&id=260d3ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d3ab0",
  null
  
)

export default component.exports